import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react"
import { useTheme } from "next-themes"
import { Toaster as Sonner, type ToasterProps } from "sonner"

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      richColors
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:shadow-2xl group-[.toaster]:border-none group-[.toaster]:rounded-2xl",
          error: "!bg-[#ef233c] !text-white",
          success: "!bg-[#4CAF50] !text-white",
          warning: "!bg-[#FFC107] !text-black",
          info: "!bg-blue-500 !text-white",
          default: "group-[.toast]:bg-white group-[.toast]:text-black group-[.toast]:border-gray-100",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
